<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "ProfileAction",
  methods: {
  }
}
</script>

<style scoped>

</style>